module.exports = __webpack_public_path__ + "img/other1.79ef3f02.png";